export const DEFAULT_REPRESENTATIVE_FILTERS = {
  status: { id: "TODOS", value: "TODOS", label: "Todos" },
  region: null,
  grupoEconomico: null,
  razaoSocial: null,
  cnpj: "",
  search: "",
};

export const SELECT_ALL_PRODUCTS_MAX = 2000;

export function mergeProductsByCodigo(existing = [], incoming = []) {
  const map = new Map();
  existing.forEach((p) => {
    if (p?.Codigo != null) map.set(p.Codigo, p);
  });
  incoming.forEach((p) => {
    if (p?.Codigo != null) map.set(p.Codigo, p);
  });
  return Array.from(map.values());
}

export function hasUnsavedWizardWork({
  currentStep,
  formData,
  selectedProducts,
  representatives,
}) {
  return (
    currentStep > 0 ||
    !!formData?.name?.trim() ||
    !!formData?.description?.trim() ||
    (selectedProducts?.length ?? 0) > 0 ||
    (representatives?.length ?? 0) > 0
  );
}

export const WIZARD_LEAVE_CONFIRM_MESSAGE =
  "Existem alterações não salvas. Deseja sair e descartar o progresso?";

export function isStepReady(
  step,
  { formData, selectedProducts, representatives },
) {
  if (step === 0) {
    const hasPayments =
      (formData.paymentConditions?.length ?? 0) > 0 ||
      !!formData.paymentCondition?.IdCondicaoPagamento;
    const hasPriceTables =
      (formData.priceTables?.length ?? 0) > 0 ||
      !!formData.priceTable?.CodTabelaPreco;
    return (
      !!formData.brand?.value &&
      !!(
        (formData.initialDate && formData.finalDate) ||
        formData.untilSoldOut
      ) &&
      !!formData.name?.trim() &&
      hasPayments &&
      hasPriceTables &&
      !!(formData.byLine || formData.byOrder)
    );
  }

  if (step === 1) {
    return (selectedProducts?.length ?? 0) > 0;
  }

  if (step === 2) {
    return (representatives?.length ?? 0) > 0;
  }

  return false;
}

export function getStepValidationHint(step, state) {
  if (isStepReady(step, state)) return null;

  if (step === 0) {
    const missing = [];
    if (!state.formData?.brand?.value) missing.push("marca");
    if (
      !state.formData?.untilSoldOut &&
      (!state.formData?.initialDate || !state.formData?.finalDate)
    ) {
      missing.push("período de vigência");
    }
    if (!state.formData?.name?.trim()) missing.push("nome da vitrine");
    const hasPayments =
      (state.formData?.paymentConditions?.length ?? 0) > 0 ||
      !!state.formData?.paymentCondition?.IdCondicaoPagamento;
    if (!hasPayments) missing.push("condição de pagamento");
    const hasPriceTables =
      (state.formData?.priceTables?.length ?? 0) > 0 ||
      !!state.formData?.priceTable?.CodTabelaPreco;
    if (!hasPriceTables) missing.push("tabela de preço");
    if (!state.formData?.byLine && !state.formData?.byOrder) {
      missing.push("regra por linha ou por pedido");
    }
    return `Preencha: ${missing.join(", ")}.`;
  }

  if (step === 1) {
    return "Adicione ao menos um produto à vitrine.";
  }

  if (step === 2) {
    return "Selecione ao menos um representante.";
  }

  return null;
}
